<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap
      >
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4 >
          <BaseCard class="my-3">
            <VCardTitle>
                            <span class="headline">
                                Sign In - Beta!
                            </span>
            </VCardTitle>


            <VCardText>
              <Email />
              <Password  />

              <VLayout class="mt-5 align-content-center">
                <VFlex xs5>
                  <v-divider></v-divider>
                </VFlex>
                <VFlex xs2></VFlex>
                <VFlex xs5>
                  <v-divider></v-divider>
                </VFlex>
              </VLayout>

            </VCardText>

            <VCardActions>
              <BaseBtn style="text-transform: none;" text  to="/auth/signup" >
                Sign Up
              </BaseBtn>
              <VSpacer/>
              <BaseBtn style="text-transform: none;" text  to="recover">
                Forgot Password ?
              </BaseBtn>

            </VCardActions>

          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>
  export default {
    components: {
      Email: () => import('@/views/auth/Email'),
      Password: () => import('@/views/auth/Password')
    },
    data: () => ({
      model: 0,
    }),
    mounted () {
      let l = this.$store.getters['cognito/isLoggedIn'];
      if(l && this.$route.path.includes('auth')){
        this.$router.push('/')
      }
    },
  }
</script>
